import Box from "@material-ui/core/Box";
import { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import React, { useState } from "react";
import ActiveUsersTable from "./ActiveUsersTable";
import CustomDateRangePicker from "./CustomDateRangePicker";
import DateRange, { stringifyDateRange } from "./DateRange.model";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    "& > * + *": {
      marginBottom: theme.spacing(3),
    },
  },
  subHeading: {
    display: "block",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "1.5rem",
    marginBottom: theme.spacing(1),
  },
}));

interface AdminActiveUsersProps {
  className?: string;
}

const AdminActiveUsers: React.FC<AdminActiveUsersProps> = ({ className }) => {
  const [activeUserDays, setActiveUserDays] = useState(7);
  const [dateRange, setDateRange] = useState<DateRange<string> | null>(null);
  const classes = useStyles();

  const handleDateRangeChange = (range: DateRange<Date> | null): void => {
    setDateRange(range && stringifyDateRange(range));
  };

  return (
    <Box className={clsx([className, classes.container])}>
      <div className={classes.subHeading}>Daily Active Users</div>
      <CustomDateRangePicker onChange={handleDateRangeChange} />
      <ActiveUsersTable activeUserDays={activeUserDays} dateRange={dateRange} />
    </Box>
  );
};

export default AdminActiveUsers;
